import { render, staticRenderFns } from "./projects_by_avg_completion_time_by_type.vue?vue&type=template&id=7be674eb&scoped=true&"
import script from "./projects_by_avg_completion_time_by_type.vue?vue&type=script&lang=js&"
export * from "./projects_by_avg_completion_time_by_type.vue?vue&type=script&lang=js&"
import style0 from "./projects_by_avg_completion_time_by_type.vue?vue&type=style&index=0&id=7be674eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be674eb",
  null
  
)

export default component.exports